import { parseMarkup, type MentionUser } from '../utils/mentionMarkup';

export type MentionTextProps = {
  value: string; // Markup format: "@[Name](id)"
  onMentionClick?: (user: MentionUser) => void;
  className?: string;
};

/**
 * Read-only component for displaying text with mentions
 * Parses "@[Name](id)" markup and renders mentions as styled, clickable tokens
 */
export default function MentionText({
  value,
  onMentionClick,
  className = '',
}: MentionTextProps) {
  const segments = parseMarkup(value);

  return (
    <span className={`mention-text ${className}`}>
      {segments.map((segment, index) => {
        if (segment.type === 'text') {
          return <span key={index}>{segment.text}</span>;
        } else {
          return (
            <span
              key={index}
              className="mention-token"
              onClick={() => onMentionClick?.({ id: segment.id, display: segment.display })}
              role={onMentionClick ? 'button' : undefined}
              tabIndex={onMentionClick ? 0 : undefined}
            >
              @{segment.display}
            </span>
          );
        }
      })}

      <style>{`
        .mention-text {
          white-space: pre-wrap;
          word-break: break-word;
        }

        .mention-text .mention-token {
          color: #1976d2;
          background: rgba(25, 118, 210, 0.08);
          border-radius: 3px;
          padding: 1px 3px;
          font-weight: 500;
          cursor: ${onMentionClick ? 'pointer' : 'default'};
          transition: background-color 0.15s;
        }

        .mention-text .mention-token:hover {
          background: ${onMentionClick ? 'rgba(25, 118, 210, 0.15)' : 'rgba(25, 118, 210, 0.08)'};
        }
      `}</style>
    </span>
  );
}

